import theme from 'theme'

const THEME_FONT_COLOR_OPTIONS = [
  { id: theme.palette.common.white, name: 'Branco' },
  { id: theme.palette.common.black, name: 'Preto' },
]

const MIN_ZOOM = 50
const MAX_ZOOM = 200

const ATTENDANCE_BASE_ITEMS = [
  'Solicitar atendimento',
  'Atendimento à ANPD',
  'Acompanhar meu histórico',
]

const POLICIES_DESCRIPTION =
  'Uma boa prática de proteção de dados pessoais, que demonstra o espírito e a ' +
  'cultura da organização, é a existência de políticas que têm o objetivo de ' +
  'proteger os dados pessoais e garantir aos titulares de dados o exercício de ' +
  'todos os seus direitos. Para dar transparência sobre a proteção de dados ' +
  'pessoais, aqui são tornadas públicas as políticas de privacidade da ' +
  'organização, para que qualquer interessado possa consultá-las e entender ' +
  'como esta organização se comporta quando o assunto é proteger dados pessoais.'

export default {
  THEME_FONT_COLOR_OPTIONS,
  MIN_ZOOM,
  MAX_ZOOM,
  ATTENDANCE_BASE_ITEMS,
  POLICIES_DESCRIPTION,
}
